import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serviceurl } from '../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class PlayerViewService {

  constructor(private httpClient:HttpClient) { }

  addLocationPointInfo(data:any):Observable<any>{
    return this.httpClient.post<any>(serviceurl +'sharedlocation/characterid/location/',data)
  }
}


